import { useEffect } from 'react'
import clsx from 'clsx'
import { useNotificationStore } from '../store'
import { Notification } from './Notification'
import styles from './Notification.module.scss'

const NOTIFICATION_DELAY = 2000

export const NotificationProvider = () => {
    const { notification, clearNotification } = useNotificationStore()

    useEffect(() => {
        if (!notification || notification.manualDismiss) return

        const timer = setTimeout(() => {
            clearNotification()
        }, NOTIFICATION_DELAY)

        return () => clearTimeout(timer)
    }, [notification])

    return (
        <>
            <Notification
                {...notification}
                clearNotification={() => {
                    clearNotification()
                    notification?.onDismiss?.()
                }}
                className={clsx(
                    { [styles.show]: !!notification, [styles.autoDismiss]: !notification?.manualDismiss },
                    notification?.className
                )}
            />
        </>
    )
}
